// kitchen/web/src/components/DishIngredientsModal.tsx
// Modal che mostra titolo piatto + ingredienti in lista puntata.
// Aperto al click sul titolo di un piatto nella vista per-tavolo.

import { X } from "lucide-react";

interface DishIngredientsModalProps {
  /** Item KitchenOrderItem cliccato (porta dish.recipe.items con ingredienti). */
  item: any;
  onClose: () => void;
}

/** Estrae la lista nomi ingredienti dalla ricetta del piatto (null-safe). */
function extractIngredients(item: any): string[] {
  const recipe = item?.dish?.recipe;
  const items = (recipe?.items ?? []) as any[];
  const names: string[] = [];
  for (const ri of items) {
    const name = ri?.ingredient?.name ?? ri?.recipe?.name;
    if (name && typeof name === "string") names.push(name.trim());
  }
  return names;
}

export default function DishIngredientsModal({
  item,
  onClose,
}: DishIngredientsModalProps) {
  const dishName: string = item?.dish?.name ?? "Piatto";
  const ingredients = extractIngredients(item);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
      onClick={onClose}
    >
      <div
        className="bg-kds-surface rounded-2xl border border-kds-muted/30 shadow-2xl w-full max-w-lg max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header: titolo piatto */}
        <div className="px-6 py-5 border-b border-kds-muted/20">
          <h2 className="text-3xl font-extrabold text-kds-text leading-tight">
            {dishName}
          </h2>
        </div>

        {/* Body: ingredienti in lista puntata */}
        <div className="px-6 py-5 overflow-y-auto flex-1">
          <p className="text-sm uppercase tracking-widest text-kds-muted font-bold mb-3">
            Ingredienti
          </p>
          {ingredients.length === 0 ? (
            <p className="text-kds-muted text-lg italic">
              Nessun ingrediente registrato per questo piatto.
            </p>
          ) : (
            <ul className="list-disc list-inside space-y-2">
              {ingredients.map((name, i) => (
                <li key={i} className="text-xl text-kds-text leading-snug">
                  {name}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Footer: bottone chiusura grande */}
        <div className="px-6 py-5 border-t border-kds-muted/20">
          <button
            type="button"
            onClick={onClose}
            className="w-full flex items-center justify-center gap-2 py-4 rounded-xl bg-kds-card text-kds-text text-xl font-bold hover:bg-kds-card/70 transition-colors min-h-[56px]"
          >
            <X size={24} />
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
}
